// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.search-by-descr__text[data-v-c3ca8bc4] {\n  margin-bottom: 15px;\n}\n.search-by-descr__filter[data-v-c3ca8bc4] {\n  margin-bottom: 5px;\n  font-size: 12px;\n}\n.lang-filter[data-v-c3ca8bc4] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 3px;\n}\n.search-by-descr__filter[data-v-c3ca8bc4]:last-child {\n  margin-bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
